/** PrivacyPage — 개인정보처리방침 정적 페이지. API 조회 없이 코드에 내장된 본문을 그대로 렌더한다. */
import { legalDocStyles } from './legal/legalDocStyles';
import { privacyContent } from './legal/privacyContent';
import { ScrollTopButton } from '@indipia/ui-core';

export function PrivacyPage() {
  return (
    <div className="legal-doc">
      <style>{legalDocStyles}</style>
      <div className="page" dangerouslySetInnerHTML={{ __html: privacyContent }} />
      {/* 스크롤 맨 위로 (§15.55) — Shell 밖 정적 문서라 스크롤 소유자가 window 다(조상에 스크롤 영역이 없다) */}
      <ScrollTopButton />
    </div>
  );
}
